<template>
    <LineChartGenerator
        :data="internal_value"
        :options="options"
    />
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { Line as LineChartGenerator } from 'vue-chartjs'

import {
    Chart as ChartJS,
    Title,
    Legend,
    Tooltip,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement,
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, LineElement, LinearScale, CategoryScale, PointElement)

export default {
    name: 'LineChart',
    props: {
        datasets: {
            type: Array,
            default: () => [],
        },
        labels: {
            type: Array,
            default: () => [],
        },
    },
    mixins: [],
    components: { LineChartGenerator },
    data() {
        return {
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false,
                    },
                },
                scales: {
                    y: {
                        suggestedMax: 5,
                        beginAtZero: true,
                    },
                },
            },
        }
    },
    computed: {
        internal_value() {
            return {
                labels: this.labels,
                datasets: this.datasets,
            }
        },
        ...mapGetters([]),
        ...mapState([]),
    },
    watch: {},
    methods: {
        ...mapActions([]),
    },
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
}
</script>

<style scoped lang="sass"></style>
